<div class="toolbar">
  <span>
    <input autofocus class="standardTextBox" [(ngModel)]="criteria.searchTerm" (keyup)="handleKeyUp($event)"/>
    @if (organizations()) {
      <select [(ngModel)]="criteria.orgUnitId" class="userSelection">
        @if (hasRole('IECIT')) {
          <option value="">All Users</option>
        }
        @for (organization of organizations(); track organization) {
          <option [value]="organization.code">{{ organization.description }}</option>
        }
      </select>
    }
    <select [(ngModel)]="criteria.statusCode" class="userSelection">
      <option value="ACTV">Active Users</option>
      <option value="IACT">Inactive Users</option>
    </select>
    <button matButton="text" [disabled]="isBusy()" (click)="searchPeople()">
      <span>
        <mat-icon class="size-16">search</mat-icon>
        <label>Search</label>
      </span>
    </button>
    @if (hasRole('IECIT')) {
      <button matButton="text" [disabled]="isBusy()" (click)="newPerson()">
        <span>
          <mat-icon class="size-16">add</mat-icon>
          <label>New</label>
        </span>
      </button>
    }
  </span>
</div>
<div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (searchResults()) {
    <div class="results">
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Please select a user to see detail</td>
          </tr>
        </thead>
      </table>
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">ID</td>
            <td class="tableCell centeredCell headerCell">Last Name</td>
            <td class="tableCell centeredCell headerCell">First Name</td>
            <td class="tableCell centeredCell headerCell">Title</td>
            <td class="tableCell centeredCell headerCell">Type</td>
            <td class="tableCell centeredCell headerCell">Status</td>
            <td class="tableCell centeredCell headerCell">Phone</td>
            <td class="tableCell centeredCell headerCell">Primary Org</td>
            <td class="tableCell centeredCell headerCell">Primary Org Description</td>
          </tr>
        </thead>
        @for (result of searchResults(); track result) {
          <tr
            (click)="selectPerson(result)">
            <td class="tableCell">{{ result.personId }}</td>
            <td class="tableCell">{{ result.lastName }}</td>
            <td class="tableCell">{{ result.firstName }}</td>
            <td class="tableCell">{{ result.title }}</td>
            <td class="tableCell">{{ result.typeDescription }}</td>
            <td class="tableCell">{{ result.statusCode }}</td>
            <td class="tableCell">{{ result.defaultPhoneNumber }}</td>
            <td class="tableCell">{{ result.primaryOrgUnitId }}</td>
            <td class="tableCell">{{ result.primaryOrgUnitDescription }}</td>
          </tr>
        }
      </table>
    </div>
  }
  @if (maxPage() > 1) {
    <div class="resultNavigation toolbar">
      <span class="spacer"></span>
      <span>
        <button matButton="text" [disabled]="isBusy() || criteria.pageNumber === 1" (click)="previousPage()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <label>Previous</label>
          </span>
        </button>
        <label class="paginationStatus">Page {{ criteria.pageNumber }} of {{ maxPage() }}</label>
        <button matButton="text" [disabled]="isBusy() || criteria.pageNumber >= maxPage()" (click)="nextPage()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_right</mat-icon>
            <label>Next</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
    </div>
  }
</div>
